import { observer } from "mobx-react";
import React from "react";
import { useNotificationStore } from "../../store";
import "./Notification.css";
import { AonAlert } from "../../components/core/AonAlert";
import { AonButton } from "../../components/core/AonButton";
import { BUTTON_VARIANT } from "../../components/core/AonButton/consts";
var Notification = observer(function () {
    var notificationStore = useNotificationStore();
    var handleClose = function () {
        notificationStore.clearNotification();
    };
    var AlertBody = function () {
        return (React.createElement("div", null,
            React.createElement("h5", null, notificationStore.heading),
            React.createElement("p", null, notificationStore.message),
            notificationStore.showOkButton &&
                React.createElement("div", { className: "noti-ok-button" },
                    React.createElement(AonButton, { style: { paddingInline: "5px" }, variant: BUTTON_VARIANT.PROMINENT, onClick: function () { return handleClose(); } }, "ok"))));
    };
    return React.createElement("div", { style: notificationStore.visible ? {} : { display: "none" }, className: "mainContainer" }, React.createElement(AonAlert, { onClose: handleClose, header: "", variant: notificationStore.type, visible: notificationStore.visible, children: React.createElement(AlertBody, null) }));
});
export default Notification;
